import { Trans } from "@lingui/macro";
import IcArb from "img/ic_arb_24.svg?react";
import IcArrowRight from "img/ic_arrow_right.svg?react";
import { useHistory } from "react-router-dom";

export function LaunchSection() {
  const history = useHistory();

  const goToTradeArbitrum = () => {
    history.push("/trade");
  };

  const Icon = IcArb;
  return (
    <section className="flex w-full items-center justify-center bg-white px-16 py-80 text-slate-900 sm:px-40 sm:py-[120px]">
      <div className="flex max-w-[1200px] flex-col items-stretch justify-center gap-24 sm:items-center lg:flex-row">
        <div className="flex flex-1 flex-col items-stretch sm:items-start">
          <h2 className="text-heading-2 mb-20 sm:mb-24">
            <Trans>Runs entirely on public chains</Trans>
          </h2>
          <p className="mb-36 text-18 font-normal leading-body-md -tracking-[0.036px] sm:mb-24">
            <Trans>
              Operates on open, permissionless networks to ensure transparency, decentralisation, and unrestricted
              access
            </Trans>
          </p>
          <button
            className="btn-landing mb-36 rounded-8 bg-blue-200 px-16 py-12 text-16 text-white sm:mb-0"
            onClick={goToTradeArbitrum}
          >
            <Trans>Launch App</Trans>
          </button>
        </div>
        <div className="grid w-full grid-flow-row grid-cols-1 gap-16 md:grid-cols-3 lg:w-auto lg:grid-cols-2">
          <div className="bg-gray-200 lg:col-start-1 lg:row-start-1">
            <button
              onClick={goToTradeArbitrum}
              className="group inline-flex w-full select-none items-center gap-12 rounded-16 bg-gray-1000 p-12 pr-20 transition-colors duration-180 hover:bg-[#EFF0F4] lg:w-[288px]"
            >
              <div className="border-1/2 flex h-60 w-60 flex-shrink-0 items-center justify-center rounded-12 border-[#E8EAF2] bg-white">
                <Icon className="size-24" />
              </div>
              <span className="text-16 font-medium -tracking-[0.768px] sm:text-24">Arbitrum</span>
              <IcArrowRight className="ml-auto size-18 translate-x-0 transition-all duration-180 ease-in-out group-hover:translate-x-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
